import { Injectable, Inject } from '@angular/core';
import * as jsEncrypt from 'jsencrypt';
import { ClientCookie } from '@libs/client-cookie';
import { Base64 } from 'js-base64';
import { Location } from '@angular/common';
import { PlatformDetect } from '@core/libs/platform/platform-detect';
import { JSBridgeService } from './jsbridge.service';
import { ProfileInfo } from '@models/user-info-model';
import { PinInfo } from '@models/pass-info-model';
import { CountryList, ProvinceList } from '@models/countrys-model'
import { tempPub, tempPri, bussinessCodeMap, wxTrackingMap, platChannelCodeMap } from '@libs/config/profile-mapping';
import { FooterBreadcrumbBase } from '@shdr/ditto-ui/dui/footer/footer.interface';
import { ErrInfo } from '@models/com-err-model';

@Injectable({
  providedIn: 'root'
})
    
export class FactoryService {
  private urlData: URLSearchParams;
  public curEnv: string; // current env (latest | stage | lt | d1 | d2 | dx.. | sl )
  public sdkEnv: string// use for sdk init env (latest | stage | lt01 | d1 | d2 | dx.. | sl | prod)
  public cdnUrl: string;
  public language: string;// (zh-cn | en | ja)
  public logined: boolean = false;
  public toLogin: boolean = false;// use for control user enter login page when ther is no login status
  public swid: string;
  public isWebStyle: boolean = false;
  public isMobileWebStyle: boolean = false;
  public isNotHeaderFooter: boolean = false; // GR、MO dont need header&footer in brower
  public trackingId: string;
  public entryCode: string; //entryCode same as trackingId, use for check activity, the value like :202504_VS_Wennie_Luckydraw 
  public openId: string;
  public unionId: string;
  public returnUrl: string;
  public delta: number;
  public pubConfigs: any; //ETCD resource
  public closedWxMenu: boolean = false; // close wechat/minip system menu
  public errCode: string; //use for check error code in error page
  public errList: ErrInfo[];
  public sensitiveWordsErr: boolean = false;//record sensitive words error
  public completeFlag: boolean = false; //use for check complete-info page routing
  public channelCode: string;
  public businessCode: string;
  public wxHome: string = '/unification/profile/my-center'; //web home page path
  public visitorFlagTTL: number = 7776000; // defeault ttl 90 days (7776000s)  
  public updatePhoneFlow: string; //use for check which flow is update phone (edit | logout)
    
  public countries: CountryList;
  public provinces: ProvinceList;
  public shdrMktOptIn: boolean = false; // agree know more about Shanghai Disney Resort’s progress/info in login page
  public userInfo: ProfileInfo;
  public selectAvatarId: string; //use for mark select avatar id in change-avatar
  public tokenInfo: any;
  public funcType: string; //function type
  public pinType: string; //pincode type for diff function flow (phonePin/legacyPhonePin/cspPhonePin/forgetPwdEmail/forgetPwdPhone/deleteAcct/phoneUpdate)
  public pinMode: string; //use for check pincode mode (SMS | Voice)
  public voiceFunctions: any = ['phonePin', 'legacyPhonePin', 'cspPhonePin', 'forgetPwdPhone', 'deleteAcct', 'phoneUpdate'];
  public pinInfo: PinInfo = {
    countDownSeconds: null,  //pin-code info from api
    pinErr: false,
    pinTimesErr: false,
    errMsg: '',
    pinCode: null
  };
  public resendPin: boolean = false; //control resend pincode falg
  public isRegister: boolean = false;
  public phoneExist: boolean = false; //use for check phone exsit when update-phone
  public phoneNoMatch: boolean = false;//check enter-phone whether match with old-phone
  public showGuestIdCardPop: boolean = false;//control guest-edit page show IDCard policy drawer popup

  //biometric info
  public bimcCheckd: boolean = false; //use for record biometric checkbox is checked
  public bimcHasPwd: boolean = false; //use for record user has biometric password
  public bimcType: string; //biometric type (faceid/touchid)
  public bimcInitChecked: boolean = false; //use for check biometric init or not

  //check member
  public isMember: boolean = false;
  public isUpMember: boolean = false;
  public mberNoCountry: boolean = false; //the member have not complete country info
  public mberNoBirth: boolean = false; //the member have not complete birth info
  public notToLogin: boolean = false; //use for control dont to do login when getUserInfo getAccessToken faild

  // reset pssword start--
  public oldPwd: string;
  public resetType: string; // check reset verify type (phone | email)
  public resetEmail: string;
  public resetMobileAreaNum: string;
  public resetMobile: string;
  public backToLogin: boolean = false;
  public resetPwdModelShow: boolean = false;
  public resetPwdModelMsg: string;
  // reset pssword end--
  
  //common single popup
  public showSinglePop: boolean = false;
  public popTitle: string = 'Profile.Common.Txt.Reminder';
  public popMsg: string;
  public descPip: boolean = true; //control use pip for desc

  //common toast
  public showToast: boolean = false;
  public toastText: string;
  public toastSuccessFlag: boolean;
  public toastMarginBtm: string;
  public toastType: string;

  // web common breadcrumb 
  public footerBreadcrumbData: FooterBreadcrumbBase[] = [];
  public breadcrumbTitle = ''; 

  public inLimit= false; // 是否正在处理限流
  private limitType: '' | 'refresh' | 'toast' = ''; // 处理限流方式（refresh page / toast）

  public timeOutErr: string = 'TimeoutError';
  public domainUrl = 'shanghaidisneyresort.com';
  public isoCountryCodeCN: string = 'CN'; // 中国内地 isoCountryCode2 为 CN

  public mberTracking: boolean = false;
  public isSafari: boolean = false;
  public isPostMsg: boolean = false; // is postmsg token info for the current channle

  constructor(
    private location: Location,
    private cCookie: ClientCookie,
    private platform: PlatformDetect,
    private JSBridgeSer: JSBridgeService
  ) { }

  setLimitType(param: '' | 'refresh' | 'toast') {
    this.limitType = param;
  }

  getLimitType() {
    return this.limitType;
  }

  /*
  language priority: path > user setting > platform setting > system setting
  value is（zh|en), only use for internal project.
  */
  //todo: integrate language 'ja'
  async getLanguage() { 
    if (this.language) return this.language;
    const path = this.location.path();
    const langs = ['/en/', '/ja/', '/zh/', '/zh-cn/']
    if (langs.find(item => path.includes(item))) { 
      this.language = (path.includes('/zh/') || path.includes('/zh-cn/'))? 'zh-cn' : (path.includes('/ja/') ? 'ja' : 'en');
    } else { 
      let lang;
      if (this.platform.isApp()) {
        const resp = await this.JSBridgeSer.callJSBridge('getLanguage');
        console.log('app getLanguage resp..', resp);
        lang = resp?.language || navigator.language;
      } else { 
        let wxLang;
        if (this.platform.isWx()) { 
          // wx userAgent like 'XXXX/XXXX Language/en(zh-cn) XXX/XXX'
          const ua = navigator?.userAgent;
          const nvLang = /(Language)/.test(ua)? ua?.split('Language/')[1] : null;
          console.log('getLanguage nvLang...', nvLang);
          wxLang = nvLang? nvLang.substring(0,2) : null;
        }
        lang = wxLang || navigator?.language;  
      } 
      /** 
       * set language as 'en' when there isn't get language from URL|Brower|System
      */
      console.log('getLanguage lang...', lang);
      const langCN: boolean = (lang === 'zh' || lang === 'zh-cn' || lang === 'zh-CN' || lang === 'zh_CN');
      const langJA: boolean = lang === 'ja';
      this.language = (lang && lang.length > 0)? (langCN? 'zh-cn' : (langJA? 'ja' : 'en') ): 'zh-cn';
    }
    return this.language;
  }

 /**
  * get env in current origin for 'sdk init' and 'cookie suffix'
  * latest: latest
  * stage: stage 
  * lt: lt01 
  * ddp: latest
  * sl: null (sdk env is 'prod') 
  * prod: null (sdk env is 'prod') 
  */
  getEnv(sdkFlag?: boolean) { 
    if (sdkFlag && this.sdkEnv || !sdkFlag && this.curEnv) {
      return sdkFlag? this.sdkEnv : this.curEnv;
    } else { 
      const host = location.host;
      const env = ((/localhost/).test(host) || (/d1/).test(host)) ? 'latest' :
        ( host.match(/(\S*).www/) && host.match(/(\S*).www/)[1] || 
          host.match(/(\S*).wechat/) && host.match(/(\S*).wechat/)[1] ||
          host.match(/(\S*).central/) && host.match(/(\S*).central/)[1]
        ); 
      this.curEnv = env === 'sl' ? '' : env;
      this.sdkEnv = (env && env !== 'sl') ? env : 'prod';
      return sdkFlag? this.sdkEnv : this.curEnv;
    }
  }

  getVisitorFlagTTL(): number { 
    return this.pubConfigs?.businessConfig?.visitorFlagExpire || this.visitorFlagTTL;
  }

  getIsDDPEnv() { 
    const host = location.host;
    return (/d1/).test(host);
  }

  getBreadCrumb() {
    return this.footerBreadcrumbData;
  }

  setBreadCrumb(backTitle, isAccSetting) {
    // 首次加载面包屑
    if (!this.footerBreadcrumbData.length) {
      // 面包屑首页处理方式与其他team保持统一
      this.footerBreadcrumbData[0] = {
        title: '',
        router: `/${this.language}`
      }
      this.footerBreadcrumbData[1] = {
        title: backTitle,
        router: `${this.language}/shprofile/profile` + (isAccSetting ? '/setting' : '')
      }
      this.breadcrumbTitle = backTitle;
    } else if (this.footerBreadcrumbData.length && this.breadcrumbTitle !== backTitle) {
      // 若返回title一致，不需要更改
      this.footerBreadcrumbData[1] = {
        title: backTitle,
        router: `${this.language}/shprofile/profile` + (isAccSetting ? '/setting' : '')
      }
      this.breadcrumbTitle = backTitle;
    } else {
      console.log('footer bread:', this.footerBreadcrumbData)
    }
  }

  public getCNDUrl(): string {
    let url = this.cdnUrl;
    if (!url) {
      let tmpT = setInterval(() => {
        if (this.cdnUrl) {
          clearInterval(tmpT);
          return `${this.cdnUrl}/profile-web-ui`;
        }
      }, 100);
      setTimeout(() => {
        clearInterval(tmpT);
      }, 3000);
    } else { 
      return `${url}/profile-web-ui`;
    }
  }


  public setSWID(swid: string): void { 
    if (swid && swid !== 'null' && swid !== 'undefined') { 
      this.swid = Base64.encode(swid);
      sessionStorage.setItem('swid', this.swid);
    }
  }

  public getSWID(): string { 
    const swid = this.swid || sessionStorage.getItem('swid') || null;
    return swid ? Base64.decode(swid) : null;
  }

  public getLoginStatus(): boolean { 
    return this.logined || sessionStorage.getItem('logined') === 'true';
  }

  public setLoginStatus(flag: boolean) { 
    this.logined = flag;
    if (flag) {
      sessionStorage.setItem('logined', 'true');
    } else { 
      sessionStorage.removeItem('logined');
    }
  }

  public getUrlParams(key: string, localFlag = true) {
    let urlData = this.urlData;
    if (!urlData) { 
      urlData = new URLSearchParams(window.location.search);
      this.urlData = urlData;
    }
    let param = urlData?.get(`${key}`);
    if (localFlag && (!param || param === 'null' || param === 'undefined')) {
      param = localStorage.getItem(key);
    }
    return ( param && param !=='null' && param !== 'undefined') ? param : null;
  }

   //bsFlag use for set businessCode & channelCode
  public setUrlParams(bsFlag?: boolean) { 
    if (bsFlag) {
      this.setStorage('channelCode', this.getUrlParams('channelCode'));
      this.setStorage('businessCode', this.getUrlParams('businessCode'));
      this.channelCode = this.getUrlParams('channelCode');
      this.businessCode = this.getUrlParams('businessCode');
    } else { 
      this.setStorage('entry_point', this.getUrlParams('entry_point'), true);
      this.setStorage('shdr-platform', this.getUrlParams('platform'), true);
      this.setStorage('uuid', this.getUrlParams('uuid'));
      this.setStorage('cupUserId', this.getUrlParams('cupUserId'));
      this.trackingId = this.getUrlParams('tracking_id'); 
      this.entryCode = this.getUrlParams('entryCode'); 
      this.returnUrl = this.getUrlParams('returnUrl');
      this.delta = this.getUrlParams('delta') ? Number(this.getUrlParams('delta')) : null;
      this.openId = this.getUrlParams('openId');
      this.unionId = this.getUrlParams('unionId');
      this.setStorage('shdr-unionId', this.unionId);
      this.setStorage('shdr-miniOpenid', this.openId);
      sessionStorage.setItem('tracking_id', this.trackingId);
      sessionStorage.setItem('entryCode', this.entryCode);
      // 手动映射gpl的tracking上报值
      const platformMapRes = wxTrackingMap.get(this.getUrlParams('platform'));
      if (this.getBusiness() === bussinessCodeMap.GPL && platformMapRes) {
        sessionStorage.setItem('shdr-platform', platformMapRes);
      }
    }
    const pathName = location.pathname;
    const memberLanding = /(member\/landing)/.test(pathName);
    // member landing页作为特殊channel处理 SHDRP-347339
    if(memberLanding) {
      this.checkChannelCode();
    }
  }

  private setStorage(key: string, value:string, sessionFlag?: boolean) { 
    if (value && value !== 'null' && value !== 'undefined') {
      if (sessionFlag) {
        sessionStorage.setItem(key, value)
      } else { 
        localStorage.setItem(key, value);
      }
    }
  }

  async checkChannelCode() {
    // 若landing url不存在channelCode，通过userAgent获取对应channelCode
    let channelCode = this.getUrlParams('channelCode', false) || platChannelCodeMap.get(this.platform.detect());
    let businessCode = this.getUrlParams('businessCode', false) || 'Membership';
    this.setStorage('channelCode', channelCode);
    this.setStorage('businessCode', businessCode);
    this.channelCode = channelCode;
    this.businessCode = businessCode;
    let entry_point = this.getUrlParams('entry_point', false);
    if (entry_point) {
      this.setStorage('entry_point', entry_point, true);
    } else {
      sessionStorage.removeItem('entry_point');
    }
    this.mberTracking = true;
  }

  //RSA encrypt password
  public encryptCode(password: string, flag?: boolean): any { 
    console.log('encryptCode pubConfigs..',this.pubConfigs);
    if (this.pubConfigs?.ppk) {
      if (flag) {
        return true;
      } else { 
        const pubKey = `-----BEGIN PUBLIC KEY-----${this.pubConfigs?.ppk}-----END PUBLIC KEY-----`;
        let encrypt = new jsEncrypt.JSEncrypt();
        encrypt.setPublicKey(pubKey);
        const encrypted = encrypt.encrypt(password? password : 'null');
        return encrypted.toString();
      }
    } else { 
      console.log('encryptCode no ppk..', flag);
      return flag? false: password;
    }
  }

  //encrypt temporary pwd
  public tempEncryptCode(pwd: string) { 
    let jsEn = new jsEncrypt.JSEncrypt();
    jsEn.setPublicKey(Base64.decode(tempPub));
    const encodePwd = jsEn.encrypt(pwd);
    return encodePwd.toString();
  }

  //decrypt temporary pwd
  public tempDecryptCode(pwd: string) { 
    let jsDn = new jsEncrypt.JSEncrypt();
    jsDn.setPrivateKey(Base64.decode(tempPri));
    const decodePwd = jsDn.decrypt(pwd);
    return decodePwd.toString();
  }

  public setUpdatePhoneFlow(flow: string): void { 
    this.updatePhoneFlow = flow;
    sessionStorage.setItem('updatePhoneFlow', flow);
  }

  public getUpdatePhoneFlow(): string { 
    return this.updatePhoneFlow || this.getSessionInfo('updatePhoneFlow') || 'edit';
  }

  public setPinType(type: string): void { 
    this.pinType = type;
    sessionStorage.setItem('pinType', type);
  }

  public getPinType(sessionFlag?: boolean): string { 
    const sessionType = this.getSessionInfo('pinType') || 'phonePin';
    return sessionFlag? sessionType : (this.pinType || sessionType);
  }

  public setPinMode(mode: string): void { 
    this.pinMode = mode;
    sessionStorage.setItem('pinMode', mode);
  }

  public getPinMode(): string { 
    return this.getSessionInfo('pinMode') || 'SMS';
  }

  public setResetType(type?: string): void{ 
    this.resetType = type;
    sessionStorage.setItem('resetType', type);
  }

  public getResetType(): string { 
    return this.resetType || this.getSessionInfo('resetType');
  }

  //is MO business
  public isMoBZ(): boolean { 
    return this.businessCode === bussinessCodeMap.MO;
  }

  public getVisitorFlagKey(): string {
    const channel = this.getChannel();
    const business = this.getBusiness();
    return channel && business ? `${channel}_${business}_visitorFlag${this.getEnv()? `_${this.getEnv()}` :''}` : null;
  }

  //get WxOA Auth from cookie
  public getAuthKey(): string { 
    let env = this.getEnv();
    const key = env ? `woa_web_ns_authed_${env}` : 'woa_web_ns_authed';
    return this.cCookie.get(key);
  }

  public getUnionId(): string {
    let unionId = this.unionId || this.getSessionInfo('shdr-unionId', false, true);
    return unionId && decodeURIComponent(unionId) || null;
  }

  public getOpenId(): string {
    return this.openId || this.getSessionInfo('shdr-miniOpenid', false, true);
  }

  public getReturnUrl(): string { 
    const url = this.returnUrl;
    return url && url !== 'null' && url !== 'undefined' ? decodeURIComponent(url) : null;
  }

  public getChannel(): string {
    let channel =  this.channelCode || this.getSessionInfo('channelCode', false, true);
    if (!channel || channel === 'unll' || channel === 'undefined') { 
      channel = this.platform.isWx() ? 'SHDR_WeChatOA': ( this.platform.isPcWeb()? 'SHDR_Website_PC': 'SHDR_Website_Mobile');
    }
    return channel;
  }

  public getBusiness(): string { 
    return this.businessCode || this.getSessionInfo('businessCode', false, true) || 'Registration_and_Login';
  }

  public getEntryCode(): string { 
    const mberFlag = this.mberTracking || sessionStorage.getItem('mberFlag') === 'true';
    return mberFlag ? this.getSessionInfo('entry_point')  : (this.trackingId || this.getSessionInfo('tracking_id') || this.entryCode || this.getSessionInfo('entryCode') || null);
  }

  public getSessionInfo(key, JsonFlag: boolean = false, localFlag?: boolean): any { 
    const tmpVal = localFlag? localStorage.getItem(key) : sessionStorage.getItem(key);
    const res = (tmpVal && tmpVal !== '' && tmpVal !== 'null' && tmpVal !== 'undefined') ?
      (JsonFlag ? JSON.parse(tmpVal): tmpVal) : null;
    return res;
  }

  public setSinglePop(globalErr: boolean = true, msg?: string,) { 
    this.showSinglePop = true;
    this.popMsg = globalErr? 'Profile.Common.Popup.Desc.Global.Err' : msg;
  }

  public setToast(successFlag: boolean, marginBtm: string = '2rem', toastType: string = '', text?: string) { 
    this.showToast = true;
    this.toastText = text ? text : 'Profile.Common.Toast.UpdateInfo.Success';
    this.toastSuccessFlag = successFlag;
    this.toastMarginBtm = marginBtm;
    this.toastType = toastType;
    const timer = setTimeout(() => {
      this.showToast = false;
      this.toastType = '';
      clearTimeout(timer);
    }, 3000);
  }

  public isDcuMinip() { 
    const platform = sessionStorage.getItem('shdr-platform');
    return this.platform.isMiniP() && platform.includes('dcu');
  }

  public getLoginType(lgType: string): string {
    const selectIterms = this.getSessionInfo('selectIterms', true);
    return selectIterms?.bimc ? (lgType ==='phonePwd' ? 'mobile': 'email'): 'manual';
  }

  public getfaceIdEnable(): string {
    const selectIterms = this.getSessionInfo('selectIterms', true);
    return selectIterms?.bimc;
  }

  //default pinType is 'phonePin' (phone pin login)
  public getScreenType(pinType: string, logined?: boolean): string { 
    switch (pinType) { 
      case 'deleteAcct':
      case 'phoneUpdate':
        return 'edit_profile';
      case 'forgetPwdEmail':
      case 'forgetPwdPhone':
        return logined ? 'edit_profile' : 'verification_code';
      default:
        return 'verification_code';
    }
  }

  //default pinType is 'phonePin' (phone pin login)
  public getPageName(pinType: string, logined?: boolean): string { 
    switch (pinType) { 
      case 'deleteAcct':
      case 'phoneUpdate':
        return 'tools/profile/verification_code';
      case 'forgetPwdEmail':
      case 'forgetPwdPhone':
        return logined ? 'tools/profile/verification_code' : 'tools/verification/code';
      default:
        return 'tools/verification/code';
    }
  } 

  public clearLogInfo() {
    this.logined = false;
    sessionStorage.removeItem('logInfo');
    sessionStorage.removeItem('isMember');
    sessionStorage.removeItem('logined');
  }
  
  public clearCache() { 
    localStorage.removeItem('returnUrl');
    this.pinInfo = {
      countDownSeconds: null,
      pinErr: false,
      pinTimesErr: false,
      errMsg: '',
      pinCode: null
    };
  }
  
}
